import React, { Component } from 'react';
import { Button, Input, Tooltip } from 'antd';
import Highlighter from 'react-highlight-words';
import { getMasterList, deleteMaster } from '../../../Utils/FormCalls';
import { EditOutlined, SearchOutlined } from '@ant-design/icons';
import themeSettings from '../../../Utils/themeSettings.json';
import ListView from '../../../Utils/ListView';
import translation from '../../../Utils/translation';
import { StyledComponent } from '../../../CSS/style';
import { constant } from '../../../Utils/constants';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getTranslationCache } from '../../../../../selectors/language';
import { encode as base64_encode } from 'base-64';
import history from '../../../../../commons/history';
import { API_INSPECTIONCONFIG } from '../../../../../commons/api';
const urlList = {
  list: API_INSPECTIONCONFIG.GET,
  getbyId: API_INSPECTIONCONFIG.GetId,
  delete: API_INSPECTIONCONFIG.DELETE
};

class QuestionMasters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      SpecificationData: [],
      activeKey: '1',
      form: {},
      config: {
        viewTypes: ['add', 'card', 'table'],
        defaultViewType: 'table',

        filterType: 'ByAttributeValue',
        attributeList: ['InspectionId'],

        firstTitle: 'InspectionId',
        secondTitle: 'FirstName',
        thirdTitle: 'CreatedTime',

        actions: ['edit', 'delete'],
        edit: {
          byAttribute: 'Id',
          redirectURL: '/rubus/AMM/InspectionMasterDetails'
        },
        deletee: {
          byAttribute: 'Id'
        }
      }
    };
  }
  componentDidUpdate(prevprops) {
    if (prevprops.translationCache !== this.props.translationCache) {
      this.setState({
        translationCache: this.props.translationCache
      });
    }
    if (this.props.match.params.Masters !== prevprops.match.params.Masters) {
      let mastername = this.props.match.params.Masters;
      this._getAdhocDataSource();
      this.setState({ mastername });
    }
  }
  componentDidMount = async () => {
    this._getAdhocDataSource();
  };

  _getAdhocDataSource = async () => {
    let dataSource = await getMasterList(urlList.list);
    this.setState({
      dataSource,
      activeKey: '1',
      form: {}
    });
  };
  _editRecord = async (record) => {
    let { config } = this.state;
    history.push({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };
  downTimeData = (form) => {
    this.setState({
      form
    });
  };

  _deleteById = async (id) => {
    await deleteMaster(urlList.delete, id);
    let dataSource = await getMasterList(urlList.list);
    this.setState({
      dataSource
    });
  };
  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };
  handleReset = (clearFilters, confirm) => {
    clearFilters();
    this.handleSearch([], confirm);
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={translation(this.props.translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          //   icon={<SearchOutlined/>}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(this.props.translationCache, 'Search')}
        </Button>
        <Button
          // type="link"
          size="small"
          style={{ width: 90 }}
          onClick={() => {
            clearFilters();
            confirm({
              closeDropdown: true
            });
            this.setState({ searchText: '' });
          }}
        >
          {translation(this.props.translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        type="search"
        style={{ color: filtered ? '#1890ff' : undefined, fontSize: '130%' }}
      />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
  render() {
    const { dataSource, userList } = this.state;
    let { translationCache } = this.props;
    let columns = [
      {
        title: translation(translationCache, constant.InspectionId),
        dataIndex: 'InspectionId',
        key: 'InspectionId',
        filter: true,
        ...this.getColumnSearchProps('InspectionId')
      },
      {
        title: translation(translationCache, constant.InspectionDesc),
        dataIndex: 'Description',
        key: 'Description',
        filter: true,
        ...this.getColumnSearchProps('Description')
      },
      {
        title: translation(translationCache, constant.action),
        width: '600',
        render: (text, record) => (
          <>
            <Button className="ant-btn" onClick={() => this._editRecord(record)} size="middle">
              <Tooltip title={translation(translationCache, 'Edit')}>
                {' '}
                <EditOutlined />
              </Tooltip>
            </Button>
            {/* <Popconfirm
              title={translation(
                translationCache,
                'Are you sure that you want to delete the Item Master'
              )}
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={() => this._deleteById(record.Id)}
              okText="Yes"
              cancelText="No"
            >
              <Button className="ant-btn" size="middle">
                <span style={{ color: '#ff4d4f' }}>
                  {' '}
                  <Tooltip title={translation(translationCache, 'Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </span>
              </Button>
            </Popconfirm> */}
          </>
        )
      }
    ];
    let config = {
      title: translation(translationCache, 'Inspection'),

      viewTypes: ['add', 'card', 'table'],
      defaultViewType: 'table',

      filterType: 'ByAttributeValue',
      attributeList: ['InspectionId'],

      firstTitle: 'InspectionId',
      secondTitle: 'FirstName',
      thirdTitle: 'CreatedDate',

      actions: ['edit'],
      edit: {
        byAttribute: 'Id',
        redirectURL: '/rubus/AMM/InspectionMasterDetails'
      },
      deletee: {
        byAttribute: 'Id'
      }
    };
    return (
      <StyledComponent theme={themeSettings} style={{ minHeight: window.innerHeight - 143 }}>
        <ListView
          columns={columns}
          dataSource={dataSource}
          userList={userList}
          config={config}
          delete={this._deleteById}
        />
      </StyledComponent>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  translationCache: getTranslationCache()
});
export default connect(mapStateToProps)(QuestionMasters);
